import React, { useState } from "react";

const IconDropdown = ({ value, onChange, color = '#4285F4' }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Icons that actually exist in this project (from vendors.css)
  const projectIcons = [
    { value: '', label: 'Select an icon' },
    
    // Education & Learning
    { value: 'icon-graduation-1', label: 'Graduation Cap' },
    { value: 'icon-graduate-cap', label: 'Graduate Cap Alt' },
    { value: 'icon-book', label: 'Book' },
    { value: 'icon-online-learning', label: 'Online Learning' },
    { value: 'icon-online-learning-2', label: 'Online Learning 2' },
    { value: 'icon-online-learning-3', label: 'Online Learning 3' },
    { value: 'icon-online-learning-4', label: 'Online Learning 4' },
    
    // Content & Media
    { value: 'icon-video-file', label: 'Video File' },
    { value: 'icon-play', label: 'Play' },
    { value: 'icon-play-button', label: 'Play Button' },
    { value: 'icon-document', label: 'Document' },
    { value: 'icon-bookmark', label: 'Bookmark' },
    { value: 'icon-bookmark-filled', label: 'Bookmark Filled' },
    
    // Interface & Actions
    { value: 'icon-search', label: 'Search' },
    { value: 'icon-edit', label: 'Edit' },
    { value: 'icon-bin', label: 'Delete/Trash' },
    { value: 'icon-check', label: 'Check/Success' },
    { value: 'icon-star', label: 'Star/Rating' },
    { value: 'icon-setting', label: 'Settings' },
    { value: 'icon-notification', label: 'Notification' },
    
    // Charts & Analytics
    { value: 'icon-bar-chart', label: 'Bar Chart' },
    { value: 'icon-bar-chart-2', label: 'Bar Chart 2' },
    
    // People & Communication
    { value: 'icon-person', label: 'Person' },
    { value: 'icon-person-2', label: 'Person 2' },
    { value: 'icon-person-3', label: 'Person 3' },
    { value: 'icon-friend', label: 'Friend/Group' },
    { value: 'icon-comment', label: 'Comment' },
    { value: 'icon-message', label: 'Message' },
    { value: 'icon-email', label: 'Email' },
    
    // Creative & Design
    { value: 'icon-design', label: 'Design' },
    { value: 'icon-creative-design', label: 'Creative Design' },
    { value: 'icon-creative-art', label: 'Creative Art' },
    { value: 'icon-creative-web', label: 'Web Design' },
    { value: 'icon-creative-software', label: 'Software' },
    { value: 'icon-digital-art', label: 'Digital Art' },
    { value: 'icon-photo-camera', label: 'Photography' },
    
    // Technology & Tools
    { value: 'icon-tech', label: 'Technology' },
    { value: 'icon-software', label: 'Software' },
    { value: 'icon-tools', label: 'Tools' },
    { value: 'icon-working-at-home-2', label: 'Work from Home' },
    
    // Business & Professional
    { value: 'icon-architecture', label: 'Architecture' },
    { value: 'icon-announcement', label: 'Announcement' },
    { value: 'icon-megaphone', label: 'Megaphone' },
    { value: 'icon-badge', label: 'Badge/Certificate' },
    { value: 'icon-coupon', label: 'Coupon/Discount' },
    
    // Time & Calendar
    { value: 'icon-calendar', label: 'Calendar' },
    { value: 'icon-calendar-2', label: 'Calendar 2' },
    { value: 'icon-wall-clock', label: 'Clock' },
    { value: 'icon-time-management', label: 'Time Management' },
    
    // Location & Discovery
    { value: 'icon-location', label: 'Location' },
    { value: 'icon-discovery', label: 'Discovery' },
    { value: 'icon-explore', label: 'Explore' },
    { value: 'icon-global-search', label: 'Global Search' },
    
    // Special & Utility
    { value: 'icon-flag', label: 'Flag' },
    { value: 'icon-puzzle', label: 'Puzzle/Problem Solving' },
    { value: 'icon-infinity', label: 'Infinity/Unlimited' },
    { value: 'icon-translate', label: 'Translate/Language' },
    { value: 'icon-access', label: 'Access/Security' },
    { value: 'icon-save-money', label: 'Save Money' }
  ];

  const selectedIcon = projectIcons.find(icon => icon.value === value);

  const handleIconSelect = (iconValue) => {
    onChange(iconValue);
    setIsOpen(false);
  };

  return (
    <div style={{ position: 'relative' }}>
      <div 
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: '12px',
          border: '1px solid #ddd',
          borderRadius: '4px',
          cursor: 'pointer',
          backgroundColor: isOpen ? '#f8f9fa' : '#fff'
        }}
      >
        {value ? (
          <span style={{ color: '#333' }}>
            <i className={value} style={{ marginRight: '8px', color: color }}></i>
            {selectedIcon?.label}
          </span>
        ) : (
          <span style={{ color: '#666' }}>Select an icon</span>
        )}
        <span style={{ float: 'right', color: '#666' }}>
          {isOpen ? '▲' : '▼'}
        </span>
      </div>
      
      {isOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          border: '1px solid #ddd',
          borderTop: 'none',
          borderRadius: '0 0 4px 4px',
          maxHeight: '200px',
          overflowY: 'auto',
          zIndex: 1000,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          {projectIcons.map((icon) => (
            <div
              key={icon.value}
              onClick={(e) => {
                e.stopPropagation();
                handleIconSelect(icon.value);
              }}
              style={{
                padding: '10px 12px',
                cursor: 'pointer',
                borderBottom: '1px solid #f0f0f0',
                backgroundColor: value === icon.value ? '#e3f2fd' : 'transparent',
                color: '#333',
                display: 'flex',
                alignItems: 'center',
                fontSize: '14px'
              }}
              onMouseOver={(e) => {
                if (value !== icon.value) {
                  e.currentTarget.style.backgroundColor = '#f8f9fa';
                }
              }}
              onMouseOut={(e) => {
                if (value !== icon.value) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }}
            >
              {icon.value && (
                <i 
                  className={icon.value} 
                  style={{ 
                    marginRight: '8px', 
                    color: color,
                    fontSize: '14px',
                    minWidth: '16px'
                  }}
                ></i>
              )}
              <span style={{ color: icon.value ? '#333' : '#999' }}>
                {icon.label}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default IconDropdown; 